import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'sb-valuelink'
import { intlMessageShape } from 'sb-react-intl'
import cx from 'classnames'
import { object } from 'common/helpers'
import { useUniqueId, useMedia } from 'sb-hooks'

import Text from 'components/_new/typography/Text/Text'

import s from './Checkbox.scss'


const Checkbox = (props) => {
  const { children, className, valueLink, checked, readOnly, brand, label, id, labelId, dataTestId, onChange, ...rest } = props

  const { isMobile } = useMedia()

  const uniqueId      = useUniqueId()
  const checkboxId    = `checkbox_${uniqueId}`

  const rootClassName = cx(s.root, className)

  const checkboxClassName = cx(s.checkbox, {
    [s.disabled]: readOnly,
    [s.brand]: brand,
  })

  let inputProps = {
    ...object.removeKeys(rest, [ 'styles' ]),
    className: s.input,
    type: 'checkbox',
    disabled: readOnly,
    readOnly,
    checked,
    onChange,
    id: checkboxId,
    'data-testid': dataTestId,
  }

  if (valueLink) {
    inputProps = {
      ...inputProps,
      valueLink,
    }
  }

  const inputElement = React.createElement(valueLink ? Input : 'input', inputProps)

  return (
    <div className={rootClassName} data-testid={id}>
      {inputElement}
      <label className={s.checkboxLabel} htmlFor={checkboxId}>
        <span className={checkboxClassName} />
        {
          Boolean(label) && (
            <Text
              className={s.label}
              message={label}
              size={isMobile ? '14-24' : '14-16'}
              tag="span"
              id={labelId || (id ? `${id}Label` : null)}
              dataTestId={dataTestId ? `${dataTestId}Label` : null}
            />
          )
        }
        {
          !label && children && (
            <span className={s.label}>{children}</span>
          )
        }
      </label>
    </div>
  )
}

Checkbox.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  checked: PropTypes.bool,
  value: PropTypes.string,
  readOnly: PropTypes.bool,
  valueLink: PropTypes.object,
  brand: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.shape(intlMessageShape),
}

Checkbox.defaultProps = {
  checked: false,
}


export default Checkbox
